<template>
  <FoldDrawer ref="foldDrawer" :fold-title="foldTitle" :unfold-title="unFoldTitle">
    <div slot="title" class="topic-title-wrap">
      {{ title }}
      <div class="pic-control" v-if="url">
        <i class="iconfont icon-zoomIn bigger-btn" @click="zoomOut" />
        <i class="iconfont icon-zoomOut smaller-btn" @click="zoomIn" />
        <i class="iconfont icon-rotation rotate-btn" @click="handlexRotate" />
      </div>
    </div>
    <div class="pic-wrap" v-if="url">
      <div class="canvas-inner" ref="canvasWrap">
        <canvas ref="picCanvas" />
      </div>
    </div>
    <TopicAnswer v-else ref="topicAnswer" />
  </FoldDrawer>
</template>
<script>
import FoldDrawer from '@/components/FoldDrawer.vue'
import corrService from '@/service/correction'
import TopicAnswer from './TopicAnswer.vue'
import { TITLE, FOLD_TITLE, UNFOLD_TITLE } from './constant'
export default {
  components: {
    FoldDrawer,
    TopicAnswer
  },
  props: {
    classTypeId: [Number, String],
    lessonId: [Number, String],
    aiLessonId: [Number, String]
  },
  data() {
    return {
      title: TITLE,
      foldTitle: FOLD_TITLE,
      unFoldTitle: UNFOLD_TITLE,
      url: ''
    }
  },
  methods: {
    getImg(url) {
      return new Promise((resolve, reject) => {
        fabric.Image.fromURL(url, (img, e) => {
          if (e) {
            reject(e)
          } else {
            resolve(img)
          }
        },
        { crossOrigin: 'anonymous' })
      })
    },
    async init() {
      // 获取图片地址
      const img = await this.getImg(this.url)
      this.$nextTick(() => {
        this.angle = 0
        const { width } = this.$refs.picCanvas.getBoundingClientRect()
        const canvas = new fabric.Canvas(this.$refs.picCanvas, {
          preserveObjectStacking: true,
          isDrawingMode: false,
          backgroundColor: '#ffffff'
        })
        img.set({
          left: 0,
          top: 0,
          lockMovementX: true,
          lockMovementY: true,
          hasControls: false
        })
        this.img = img
        // 将图片添加到画布
        canvas.add(img)
        // 调整画布大小适配图片
        let initWidth
        let initHeight
        let zoom = 1
        if (img.width > width) {
          initWidth = width
          zoom = width / img.width
          initHeight = zoom * img.height
        } else {
          initWidth = img.width
          initHeight = img.height
        }
        canvas.setWidth(initWidth)
        canvas.setHeight(initHeight)
        canvas.setZoom(zoom)
        this.canvas = canvas
      })
    },
    zoomOut() {
      this.zoomIt(1.1)
    },
    zoomIn() {
      this.zoomIt(0.9)
    },
    zoomIt(factor) {
      const cWidth = this.canvas.width
      const cHeight = this.canvas.height
      const zoom = this.canvas.getZoom()
      this.canvas.setWidth(cWidth * factor)
      this.canvas.setHeight(cHeight * factor)
      this.canvas.setZoom(zoom * factor)
    },
    handlexRotate() {
      this.angle += 90
      this.canvas.setActiveObject(this.img)
      const img = this.canvas.getActiveObject()
      const { width, height } = this.canvas

      this.canvas.setWidth(height)
      this.canvas.setHeight(width)
      this.handleActiveObjectPosition(img)
    },
    handleActiveObjectPosition(obj) {
      obj.rotate(this.angle)
      const angleNum = this.angle % 360
      let left = 0
      let top = 0
      switch (angleNum) {
        case 90:
          left = obj.height
          break
        case 180:
          left = obj.width
          top = obj.height
          break
        case 270 :
          top = obj.width
          break
      }
      obj.set({
        left,
        top
      })
      this.canvas.requestRenderAll()
    },
    async getAnserData() {
      // 日积月累
      await this.getWorkwordAnswer()
      if (this.url) {
        // 展示图片
        this.init()
      } else {
        this.$refs.topicAnswer.topicRender(this.topicList)
      }
    },
    // 获取日积月累答案
    async getWorkwordAnswer() {
      if (this.loading) {
        return
      }
      try {
        this.loading = true
        const { classTypeId, lessonId, aiLessonId } = this
        const { aiAccompanyQuestionList, answerImg } = await corrService.workwordAnswer([classTypeId, lessonId, aiLessonId])
        this.topicList = aiAccompanyQuestionList || []
        // this.url = 'https://h-test.aixuexi.com/B:1015:K/1655913600/604d09d4e03c45ec9d78da8b45de8a75.jpeg'
        this.url = answerImg
      } catch (e) {
        throw new Error(e)
      } finally {
        this.loading = false
      }
    },
    show() {
      this.$refs.foldDrawer.show()
      this.$nextTick(() => {
        this.getAnserData()
      })
    }
  }
}
</script>
<style lang="less" scoped>
.pic-wrap {
  width: 100%;
  height: 100%;
  position: relative;
  .canvas-inner {
    width: 100%;
    height: 100%;
    overflow: auto;
  }
  canvas {
    width: 100%;
    height: 100%;
  }
}
.topic-title-wrap {
  display: flex;
  align-items: center;
  .pic-control {
    margin-left: 16px;
    padding-left: 12px;
    display: flex;
    align-items: center;
    position: relative;
    i {
      font-size: 16px;
      padding: 8px;
      font-weight: normal;
      color: #70788C;
      cursor: pointer;
      &:last-child {
        margin-right: 0
      }
    }
    &:after {
      position: absolute;
      content: "";
      width: 1px;
      height: 24px;
      background: #EBEDF0;
      top: 50%;
      left: 0;
      transform: translateY(-50%);
    }
  }
}
</style>